import React, { Component } from "react";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import TeamsTable from "./teamsTable";
import { getTeams, deleteTeam } from "./../../services/teamService";
import "react-confirm-alert/src/react-confirm-alert.css";
import _ from "lodash";

class Teams extends Component {
  state = { teams: [], sortColumn: { key: "name", order: "asc" } };

  async componentDidMount() {
    const teams = await getTeams();
    this.setState({ teams });
  }

  handleDelete = async team => {
    confirmAlert({
      title: "Delete Team",
      message: "Are you sure you want to delete '" + team.name + "'?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const teams = this.state.teams.filter(s => s.id !== team.id);
            this.setState({ teams });

            await deleteTeam(team.id);
          }
        },
        {
          label: "No",
          onClick: () => {}
        }
      ]
    });
  };

  handleSort = sortColumn => {
    this.setState({ sortColumn });
  };

  getSortedData = () => {
    const { teams, sortColumn } = this.state;
    const sorted = _.orderBy(teams, [sortColumn.key], [sortColumn.order]);
    return { teams: sorted };
  };

  render() {
    const { sortColumn } = this.state;
    const { teams } = this.getSortedData();

    return (
      <div>
        <h2>Teams</h2>
        <Link
          to="/teams/new"
          className="btn btn-primary"
          style={{ marginBottom: 20 }}
        >
          <i className="fa fa-file" />
        </Link>
        <TeamsTable
          teams={teams}
          sortColumn={sortColumn}
          onEdit={this.handleEdit}
          onDelete={this.handleDelete}
          onSort={this.handleSort}
        />
      </div>
    );
  }
}

export default Teams;



// WEBPACK FOOTER //
// ./src/components/teams/teams.jsx